import React from 'react';
import "./Footer.css";
import {theamContex} from "../../Context";
import { useContext } from "react";
import {Link} from "react-scroll";
function Footer() {
  const theme = useContext(theamContex);
    const darkMode = theme.state.darkMode;
  return (
    <div className='footer'
    style={{
      background: darkMode?'rgb(173, 241, 35)':'',
      color: darkMode?'white':'',
    }}
    >
        <div className="foot-detail">
          <a href="https://github.com/DipakPatil100" target="_blank" ><i class="fa-brands fa-github"></i></a>
          <a href="https://www.linkedin.com/in/dipakpatil100/" target="_blank"><i class="fa-brands fa-linkedin"></i></a>
          <a href="https://www.instagram.com/dipak_patil_08/" target="_blank"><i class="fa-brands fa-instagram"></i></a>
          <a href="https://www.facebook.com/profile.php?id=100009815798899" target="_blank"><i class="fa-brands fa-facebook"></i></a>
        </div>
        <div className="copyright">
            <span>Copyrigh <i class="fa-solid fa-copyright"></i> {new Date().getFullYear()}</span> 
        </div>
        <span>Made with <span><i class="fa-solid fa-heart"></i></span> by Dipak Patil</span>
        <Link spy={true} to='Navbar' smooth={true} >
          <li className="scroll-btn"><i class="fa-solid fa-chevron-up"></i></li>
        </Link>
    </div>
  )
}

export default Footer;